import { createFileRoute } from "@tanstack/react-router";

// Cửa "Chấm điểm" (CEO chốt 01/09/2026) — QC chấm phiếu, kiểm cơ sở, trưởng
// phòng tick phiếu tuần. Tách khỏi /performance vì người ĐI CHẤM và người BỊ
// CHẤM không nên chung một cửa.
type PerformanceSearch = { tab?: string | undefined; branch?: string | undefined; line?: "album" | "idphoto" | undefined };

export const Route = createFileRoute("/_app/performance/review")({
  validateSearch: (search: Record<string, unknown>): PerformanceSearch => ({
    tab: typeof search.tab === "string" ? search.tab : undefined,
    // Cơ sở mở sẵn cho thẻ Kiểm cơ sở (link từ Bảng QC, QĐ 0484).
    branch: typeof search.branch === "string" ? search.branch : undefined,
    // Nhóm bài mở sẵn ở thẻ Chấm bài (link từ Bàn làm việc QC, QĐ 0521).
    line: search.line === "album" || search.line === "idphoto" ? search.line : undefined,
  }),
});
